import Label from './Label'
import Aabb from './Aabb'
import Segmentation from './Segmentation'
import Ocr from './Ocr'
import TextCategorization from './TextCategorization'

export {
	Label,
	Aabb,
	Segmentation,
	Ocr,
	TextCategorization,
}
